import {
  Container,
  chakra,
  Flex,
  Text,
  Stack,
  Avatar,
  SimpleGrid,
  useColorModeValue,
  Box,
  Heading,
  Button,
  Image,
  Link
} from '@chakra-ui/react';

import { COLORS } from "../../../colors"

import React from 'react';

const testimonials = [
  {
      name: 'Iván Edo',
      image: '/opinion_ivan.png',
      content: `Recomiendo al 100% las clases con Sara en Somerset. Se nota que lleva muchos años de profesora porque conoce perfectamente las mayores dificultades y facilita técnicas y ejercicios para superarlas. En sus clases se trabajan todas las destrezas poniendo mucho hincapié en la parte oral y en la pronunciación. He superado con éxito tanto el nivel B2 como el C1 ¡Yo estoy encantado!`
  },
  {
      name: 'Lidia Gimenez',
      image: '/opinion_l.png',
      content: `Academia de inglés con trato muy familiar y cercano. Los profesores hacen las clases dinámicas y que aprender inglés sea divertido. Mis dos hijos han idos contentos a clase y han conseguido sus objetivos en cuanto a titulación.  La recomiendo totalmente.`
  },
  {
      name: 'Aur Villa',
      position: 'CEO',
      company: 'Olpers',
      image: '/opinion_a.png',
      content: `Nuestra experiencia en la Academia Somerset ha sido totalmente positiva. Todos los profesionales son nativos y altamente cualificados, recibiendo una atención personalizada según tus necesidades y de total apoyo a la hora de presentarte a las pruebas oficiales. Gracias a todo su personal y en especial a Sara por el Interés mostrado a lo largo de estos cursos.`
  },
  // Resto de testimonios...
];

const TestimonialCard = ({ testimonial }) => (
  <Stack
      direction="column"
      spacing={2}
      mb={5}
      justifyContent="flex-start"
      alignItems="center"
      textAlign="center"
      position="relative"
      bg={useColorModeValue('white', 'gray.800')}
      boxShadow="lg"
      rounded="md"
      p={6}
      maxW="280px" // Ajuste de la anchura máxima
      minH="360px" // Ajuste de la altura mínima
      _after={{
          content: `""`,
          w: '0',
          h: '0',
          borderColor: `transparent ${useColorModeValue('white', '#1a202c')} transparent`,
          borderStyle: 'solid',
          borderWidth: '10px 0 10px 10px',
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translate(-50%, -50%) rotate(90deg)',
          display: 'block'
      }}
  >
      <Box>
          <Text fontWeight="medium" fontSize="sm" fontFamily={"Montserrat"}>
              <Flex flexDirection='row' justifyContent='center' mb='20px'>
                  <Star fillColor="#EACA4E" />
                  <Star fillColor="#EACA4E" />
                  <Star fillColor="#EACA4E" />
                  <Star fillColor="#EACA4E" />
                  <Star fillColor="#EACA4E" />
              </Flex>
              {testimonial.content}
          </Text>
      </Box>
  </Stack>
);

const Star = ({ fillColor }) => {
  return (
      React.createElement("svg", {
          style: {
              width: '1rem',
              height: '1rem',
              fill: fillColor,
              marginRight: '0.25rem'
          },
          viewBox: "0 0 1000 1000",
          xmlns: "http://www.w3.org/2000/svg"
      },
      React.createElement("path", { d: "M972 380c9 28 2 50-20 67L725 619l87 280c11 39-18 75-54 75-12 0-23-4-33-12L499 790 273 962a58 58 0 0 1-78-12 50 50 0 0 1-8-51l86-278L46 447c-21-17-28-39-19-67 8-24 29-40 52-40h280l87-279c7-23 28-39 52-39 25 0 47 17 54 41l87 277h280c24 0 45 16 53 40z" })
      )
  );
};


const Testimonials = () => {
  return (
      <Container maxW="100vw" py={10} px={0} backgroundImage="url('/metodologia.jpg')" backgroundSize="cover" backgroundPosition="center">
          <Flex justifyContent="center" mb={8} flexDirection='column' alignItems='center' textAlign='center' >
              <Heading textAlign={"center"} as="h2" size="xl" mt={6} mb={2} fontFamily={"Montserrat"} color={'white'}>
                  Opiniones de nuestros clientes
              </Heading>
              <Text textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.100'} maxW="50vw">
                  La mejor referencia que puedes tener de Somerset Language Centre, es la opinión de nuestros alumnos. Para ello te invitamos a que puedas ver nuestras reseñas de Google, o bien te recomendamos preguntar a antiguos alumnos, y que sean ellos quienes, a través de su experiencia te hablen de todas las ventajas de nuestros cursos.
              </Text>
          </Flex>
          <SimpleGrid columns={{ base: 1, md: 3 }} placeItems="center" spacing={1} mt={12} mb={4}>
              {testimonials.map((testimonial, index) => (
                  <Box mt={10} key={index}>
                      <TestimonialCard testimonial={testimonial} />
                      <Box textAlign="center">
                          <Avatar
                              size="lg"
                              name="avatar"
                              src={testimonial.image}
                          />
                          <Box>
                              <Text fontWeight="bold" fontSize="md" fontFamily={"Montserrat"} mt='5px' color={'white'}>
                                  {testimonial.name}
                              </Text>
                          </Box>
                      </Box>
                  </Box>
              ))}
          </SimpleGrid>
          <Flex justifyContent="center" mb={8} flexDirection='row' alignItems='center' mt={20}>
              <Link href="https://www.google.com/search?sca_esv=dbec97f3c192e658&sxsrf=ACQVn08nx59R1uStk9YX7d5Bby8NGL15HA:1713785829960&q=academia+somerset&uds=AMwkrPualYqBV5Y4WTFJ28JO3GMdnyNEfgcYrqQzrBfrHmpIrQskGTtFILezT41rQOXnySmMEawPQexKlafbVd4X3DLHM1St_2KKKs8ATJgMOgeGduBUYnOH0sCy5TYme2v-MLs63um6&si=AKbGX_pcr8t4hk1b8V3SG-dEV8bVj6a_kIW7Qa3yLTtdWS9tlREFvEX4HUFLcfWNIkgbFtS2eYonpiXgf1Lp14wM6JgPaqvHKv6FMQQNuirY762bK-xWE2U%3D&sa=X&ved=2ahUKEwjdi_bc3dWFAxWDdaQEHXJTCgYQ3PALegQIEhAE&biw=1280&bih=559&dpr=1.5#" isExternal>
                  <Button
                      rounded={"full"}
                      size={"lg"}
                      fontWeight={"normal"}
                      px={6}
                      bg={COLORS.brand1}
                      color={COLORS.brand4}
                      _hover={{ bg: COLORS.brand3, color: COLORS.brand1 }}
                      fontFamily={"Montserrat"}
                      rightIcon={<Image src="/google.png" boxSize="20px" />}
                  >
                      Ver reseñas en
                  </Button>
              </Link>
          </Flex>
      </Container>
  );
};

export default Testimonials;
